module.exports = __webpack_public_path__ + "img/DE00435.07abdf41.png";